import { ColumnFilterChange, ColumnFilterAction, ColumnFilterApplied } from './column-filter/column-filter.component';
import { Row } from 'src/app/models/ui/table';

export interface FiltersMap {
  [columnId: string]: ColumnFilterApplied;
}

export class FilterService<T = Row> {
  #data: T[] = [];
  public set originalData(data: T[]) {
    this.#data = data;
  }
  public get filteredData() {
    return this.filterData();
  }

  #filters: FiltersMap = {};
  public set filters(filters: FiltersMap) {
    this.#filters = filters || {};
  }
  public get filters(): FiltersMap {
    return this.#filters;
  }

  public get filterKeys() {
    return Object.keys(this.#filters);
  }

  public get isAktiv() {
    return this.filterKeys.length > 0;
  }

  clearFilters() {
    this.#filters = {};
  }

  deleteFilter(id: string) {
    delete this.#filters[id];
  }

  setFilter(filter: ColumnFilterApplied) {
    this.#filters[filter.columnId] = filter;
  }

  filter(columnFilterChange: ColumnFilterChange): T[] {
    switch (columnFilterChange.reason) {
      case ColumnFilterAction.Redirect:
        throw new Error('Unerreichbar Code');
      case ColumnFilterAction.ResetAll: {
        this.clearFilters();
        return this.#data;
      }
      case ColumnFilterAction.Reset: {
        this.deleteFilter(columnFilterChange.columnId);
        break;
      }
      case ColumnFilterAction.Submit: {
        this.setFilter(columnFilterChange);
        break;
      }
    }

    return this.filterData();
  }

  private filterItemsByColumn(item: T, columnId: string): boolean {
    const filter = this.#filters[columnId];
    if (!filter?.items?.length) return true;

    return filter.items.some(({ name, isEmptyValue }) => {
      const value = item[columnId];
      if (isEmptyValue) return !(value || value === 0);
      return typeof value == 'number' ?
          value == +name
        : value?.toString().toLowerCase() === name.toString().toLowerCase();
    });
  }

  private filterData(): T[] {
    return !this.isAktiv ?
        this.#data
      : this.#data.filter(item => this.filterKeys.every(columnId => this.filterItemsByColumn(item, columnId)));
  }
}
